import { render, staticRenderFns } from "./Action.List.Partner.vue?vue&type=template&id=540ab997&"
import script from "./Action.List.Partner.vue?vue&type=script&lang=js&"
export * from "./Action.List.Partner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports